import { css, setColor_25476d, setFontSize_13px, setFontWeight600, setProps, styled } from "theme";

interface SFilterSelectorTitleProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFilterSelectorTitleProps>(({ isArabic }) => isArabic)(css`
  text-align: right;
`);
export const SFilterSelectorTitle = styled.div<SFilterSelectorTitleProps>`
  margin-top: 8px;
  margin-bottom: 8px;

  ${isArabicLang};
  ${setFontSize_13px};
  ${setFontWeight600};
  ${setColor_25476d};
`;
